import request from '../utils/request'

export function checkInviteCode(inviteCode) {
  return request(`/bestsmart/channelUserRelation/checkInviteCode?inviteCode=${inviteCode}`);
}

export function checkAndSaveUsername(data) {
  return request(`/bestsmart/channelUserRelation/checkAndSaveUsername`, {
    method: 'POST',
    body: JSON.stringify(data)
  });
}
